import * as React from "react";

interface IProps {
    startAdorment?: React.ReactNode;
    variant?: "plain" | "list" | "div";
    separatorVariant?: "bullet" | "dash" | "newline" | "comma" | "space";
    separator?: React.ReactNode;
    components: React.ReactNode[];
}

export const MprcBulletSeparator = () => <span>&nbsp;&bull;&nbsp;</span>;
export const MprcDashSeparator = () => <span>&nbsp;&ndash;&nbsp;</span>;
export const MprcSpaceSeparator = () => <span>&nbsp;&nbsp;&nbsp;</span>;

export const MprcJoinComponents: React.FC<IProps> = (props) => {
    if (props.components == null)
        return null;

    const c = props.components.filter(p => p != null);
    if (c.length == 0)
        return null;

    const sepComp = props.separatorVariant == "dash"
        ? <MprcDashSeparator />
        : props.separatorVariant == "bullet"
            ? <MprcBulletSeparator />
            : props.separatorVariant == "space"
                ? <MprcSpaceSeparator />
                : props.separatorVariant == "comma"
                    ? <span>,&nbsp;</span>
                    : props.separatorVariant == "newline"
                        ? <br />
                        : <span>&nbsp;{props.separator || <span>&ndash;</span>}&nbsp;</span>;

    return props.variant == "list"
        ? (
            <ul style={{ padding: "unset" }}>
                {
                    c.filter(p => p != null)
                        .map((v, index) => (
                            <li key={index}>
                                {props.startAdorment}
                                {v}
                            </li>)
                        )
                }
            </ul>
        )
        : props.variant == "div"
            ? (
                <>
                    {
                        c.filter(p => p != null)
                            .map((v, index) => (
                                <div key={index}>
                                    {props.startAdorment}
                                    {v}
                                    {index < c.length - 1 ? sepComp : null}
                                </div>)
                            )
                    }
                </>
            )
            : (
                <>
                    {
                        c.map((v, index) => (
                            <React.Fragment key={index}>
                                {props.startAdorment}
                                {v}
                                {index < c.length - 1 ? sepComp : null}
                            </React.Fragment>)
                        )
                    }
                </>
            );
};
